import {useLanguageDependentDataSSr} from './useLanguageDependentDataSsr.hook';
import {StrapiErrorCode} from '../models/strapi/strapi-error-code';

export const useErrorCodes =
    useLanguageDependentDataSSr<StrapiErrorCode[]>('error-codes');
